import axios from "axios";
import { toast } from "react-toastify";
export const GetAllPaySlipTable = (data) => {
  return {
    type: "get_allpaysliptable",
    payload: data,
    loader: false,
  };
};
export function getallPaySlipTable() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}payslip/GetAll`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllPaySlipTable(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
